import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import dynamic from 'next/dynamic';

import Span from '@deliveroo/consumer-component-library/components/Span';
import Spacer from '@deliveroo/consumer-component-library/components/Spacer';
import ChevronDown from '@deliveroo/icon-set/react/ChevronDown';
import Icon from '@deliveroo/consumer-component-library/components/Icon';
import UnstyledButton from '@deliveroo/consumer-component-library/components/UnstyledButton';
import i18n from '../../utils/i18n';

import { fulfillmentMethodType } from '../../containers/HomeFiltersFulfillmentControl/proptypes';

import styles from './styles.scss';

const FulfillmentAnimation = dynamic(import('./FulfillmentAnimation'), {
  ssr: true,
});

const HomeFiltersLogisticsControl = ({
  dateTimeLabel,
  neighborhood,
  toggleLogisticsModal,
  trackTappedLogisticsControl,
  compact,
  selectedMethod,
  withClickAndCollect,
}) => {
  const onClick = useCallback(
    () => {
      trackTappedLogisticsControl();
      toggleLogisticsModal(true);
    },
    [toggleLogisticsModal, trackTappedLogisticsControl],
  );
  const neighborhoodLabel = <Span isBold>{neighborhood}</Span>;
  const chevronIcon = (
    <Icon component={ChevronDown} color="teal" size={18} spacing="0 0 0 x-small" />
  );
  const changeLabel = (
    <Span size="small" color="teal" spacing="0 0 0 x-small">
      {i18n.gettext('Change')}
    </Span>
  );

  return (
    <UnstyledButton isBlock onClick={onClick}>
      <div className={styles.flexParent}>
        {selectedMethod &&
          withClickAndCollect && (
            <Spacer spacing="0 small 0 0">
              <FulfillmentAnimation fulfillmentMethod={selectedMethod} />
            </Spacer>
          )}

        <div className={styles.flexBlock}>
          <Span isBlock size="small" color="grey">
            {dateTimeLabel}
          </Span>
          <div className={styles.flexSplit}>
            <div className={styles.flexShrink}>
              <div className={styles.flexRow}>
                <div className={styles.flexTruncated}>{neighborhoodLabel}</div>
                {compact && chevronIcon}
              </div>
            </div>
            {!compact && changeLabel}
          </div>
        </div>
      </div>
    </UnstyledButton>
  );
};

HomeFiltersLogisticsControl.propTypes = {
  dateTimeLabel: PropTypes.string.isRequired,
  neighborhood: PropTypes.string.isRequired,
  toggleLogisticsModal: PropTypes.func.isRequired,
  trackTappedLogisticsControl: PropTypes.func.isRequired,
  compact: PropTypes.bool,
  /**
   * The currently selected fulfillment method.
   */
  selectedMethod: fulfillmentMethodType,
  /**
   * Whether the click and collect client feature flag is enabled for this user
   */
  withClickAndCollect: PropTypes.bool,
};

HomeFiltersLogisticsControl.defaultProps = {
  compact: false,
  selectedMethod: null,
  withClickAndCollect: false,
};

export default HomeFiltersLogisticsControl;
